import * as React from "react";
import { $, merge, media } from "glamor";
import IconButton from "@material-ui/core/IconButton";
import FlatButton from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { formatMessage } from "lib/globalize-util";
import theme from "styles/theme";

const styles = merge(
    {
        background: theme.palette.darkestGrey,
        color: "white",
        display: "flex",
        borderRadius: "5px",
        boxShadow: "0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149)",
        letterSpacing: ".2px",
        padding: "4px",
        bottom: "16px",
        left: "76px",
        position: "fixed",
        zIndex: 500001,
    },
    $(" > span", {
        fontSize: "14px",
        padding: "0 16px 0 32px",
        lineHeight: "48px",
        whiteSpace: "nowrap",
    }),
    $(" .updateButton", {
        marginTop: "4px !important",
    }),
    $(" .notificationButton", {
        fontFamily: theme.fontFamily,
        color: theme.palette.primary1Color,
        textTransform: "none",
        fontSize: "1.25em",
    }),
    $(" .notificationCloseButton", {
        color: theme.palette.alternateTextColor,
    }),
    media(
        "(max-width: 500px)",
        {
            left: "16px",
        },
        $(" > span", {
            padding: "0 16px 0 16px",
        })
    )
);

interface IProps {
    handleSyncProducts: () => void;
    onClearProductUpdates: () => void;
}

export const ProductSyncToaster: React.FC<IProps> = (props) => {
    const { handleSyncProducts, onClearProductUpdates } = props;
    return (
        <div {...styles} className="notificationDialog">
            <span>{formatMessage("Product data has been updated.")}</span>
            <FlatButton variant="text" onClick={handleSyncProducts} className="notificationButton">
                {formatMessage("Sync Data")}
            </FlatButton>
            <IconButton onClick={onClearProductUpdates} className="notificationCloseButton">
                <CloseIcon />
            </IconButton>
        </div>
    );
};
